/** The query key that holds the phone Discover chip. */
export const DISCOVER_SHOW_PARAM = 'show';

export type DiscoverShow = 'all' | 'stays' | 'services' | 'packages';

const SHOW_VALUES: readonly DiscoverShow[] = ['all', 'stays', 'services', 'packages'];

export function parseDiscoverShow(param: string | null): DiscoverShow {
  return SHOW_VALUES.find((value) => value === param) ?? 'all';
}
